import * as React from 'react'
import PropTypes from 'prop-types'
interface PaimentFactureIconProps extends React.SVGProps<SVGSVGElement> {
  strokeColor?: string
}

const PaimentFactureIcon: React.FC<PaimentFactureIconProps> = ({ strokeColor }) => {
  return (
    <svg width="25" height="25" 
    className={strokeColor}
    viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0208 22.9168H11.1743C7.77716 22.9168 6.0786 22.9168 4.89903 22.0858C4.56106 21.8477 4.26102 21.5653 4.00802 21.2471C3.125 20.1369 3.125 18.5383 3.125 15.3411V12.6895C3.125 9.60292 3.125 8.0596 3.61348 6.82699C4.39877 4.84539 6.05952 3.28233 8.16496 2.54324C9.47461 2.0835 11.1144 2.0835 14.394 2.0835C16.268 2.0835 17.205 2.0835 17.9533 2.3462C19.1565 2.76855 20.1055 3.66173 20.5542 4.79406C20.8333 5.49841 20.8333 6.38031 20.8333 8.1441V10.9377" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.125 12.5002C3.125 10.5825 4.67956 9.02794 6.59722 9.02794C7.29075 9.02794 8.10838 9.14947 8.78268 8.96879C9.38179 8.80825 9.84975 8.34029 10.0103 7.74116C10.191 7.06687 10.0694 6.24925 10.0694 5.55572C10.0694 3.63806 11.6241 2.0835 13.5417 2.0835" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21.875 21.3463C21.3767 22.2874 20.47 22.9168 19.4342 22.9168C17.8615 22.9168 16.5866 21.4659 16.5866 19.6761V17.8242C16.5866 16.0344 17.8615 14.5835 19.4342 14.5835C20.47 14.5835 21.3767 15.213 21.875 16.154M15.625 18.7502H19.7116" strokeWidth="2" strokeLinecap="round"/>
  </svg>

    // <svg
    //   className={strokeColor }
    //   width="20" height="22" viewBox="0 0 20 22" 
    //   fill="none" xmlns="http://www.w3.org/2000/svg"
    //   >
    //   <path
    //     d="M10.5 21H8.7273C5.46607 21 3.83546 21 2.70307 20.2022C2.37862 19.9736 2.09058 19.7025 1.8477 19.3971C1 18.3313 1 16.7966 1 13.7273V11.1818C1 8.21865 1 6.73706 1.46894 5.55375C2.22282 3.65142 3.81714 2.15088 5.83836 1.44135C7.09563 1 8.6698 1 11.8182 1C13.6173 1 14.5168 1 15.2352 1.2522C16.3902 1.65765 17.3013 2.5151 17.732 3.60214C18 4.27832 18 5.12494 18 6.81818V9.5"
    //     stroke="#A5A5A5"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //     className="group-hover:stroke-[#5754E5] group-focus:stroke-[#5754E5] stroke-[#AEB6FB]"

    //   />
    //   <path
    //     d="M1 11C1 9.159 2.49238 7.66667 4.33333 7.66667C4.99912 7.66667 5.78404 7.78333 6.43137 7.60988C7.00652 7.45576 7.45576 7.00652 7.60988 6.43136C7.78333 5.78404 7.66667 4.99912 7.66667 4.33333C7.66667 2.49238 9.1591 1 11 1"
    //     stroke="#A5A5A5"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //     className="group-hover:stroke-[#5754E5] group-focus:stroke-[#5754E5] stroke-[#AEB6FB]"

    //   />
    //   <path
    //     d="M19 19.4923C18.5216 20.3957 17.6512 21 16.6568 21C15.147 21 13.9231 19.6071 13.9231 17.8889V16.1111C13.9231 14.3929 15.147 13 16.6568 13C17.6512 13 18.5216 13.6043 19 14.5077M13 17H16.9231"
    //     stroke="#A5A5A5"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     className="group-hover:stroke-[#5754E5] group-focus:stroke-[#5754E5] stroke-[#AEB6FB]"

    //   />
    // </svg>
  )
}

export default PaimentFactureIcon
